import { useLocation } from 'react-router-dom';
import { FaInstagram, FaTwitter, FaTiktok } from 'react-icons/fa';
import { HiOutlineMail } from 'react-icons/hi';

export default function Footer() {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <footer
      className={`w-full py-10 transition-colors duration-300 ${
        isHome ? 'bg-white border-t border-gray-200' : 'bg-transparent'
      }`}
    >
      <div className="max-w-screen-2xl mx-auto px-6 md:px-10 flex flex-col items-center gap-5">
        {/* Social Icons – always black */}
        <div className="flex gap-6 text-2xl text-black">
          <a
            href="https://instagram.com/waveyyent"
            target="_blank"
            rel="noreferrer"
            className="hover:opacity-60 transition"
          >
            <FaInstagram />
          </a>
          <a
            href="https://twitter.com/waveyyent"
            target="_blank"
            rel="noreferrer"
            className="hover:opacity-60 transition"
          >
            <FaTwitter />
          </a>
          <a
            href="https://tiktok.com/@waveyyent"
            target="_blank"
            rel="noreferrer"
            className="hover:opacity-60 transition"
          >
            <FaTiktok />
          </a>
        </div>

        {/* Contact Email – always black */}
        <div className="flex items-center gap-2 text-sm text-black">
          <HiOutlineMail size={16} />
          <a href="mailto:info@waveyyent.com" className="hover:opacity-60 transition">
            info@waveyyent.com
          </a>
        </div>

        {/* Copyright – always dark gray */}
        <p className="text-xs text-gray-600">
          &copy; {new Date().getFullYear()} WAVEYENT. All rights reserved.
        </p>
      </div>
    </footer>
  );
}